<!--suppress JSUnresolvedVariable, ES6CheckImport -->
<template>
  <div
    id="carouselExampleIndicators"
    class="carousel slide mt-xl-0 wow zoomIn"
    data-ride="carousel"
  >
    <ol class="carousel-indicators">
      <li
        data-target="#carouselExampleIndicators"
        v-for="(item, index) in imgList"
        :key="item.bannerId"
        :data-slide-to="index"
        :class="index === 0 ? 'active' : ''"
      ></li>
    </ol>
    <div class="carousel-inner">
      <div
        class="carousel-item"
        v-for="(item, index) in imgList"
        :key="item.bannerId"
        :class="index === 0 ? 'active' : ''"
      >
        <a href="#"
          ><img :src="item.imgUrl" class="d-block w-100" alt="..."
        /></a>
      </div>
    </div>
    <a
      class="carousel-control-prev"
      href="#carouselExampleIndicators"
      role="button"
      data-slide="prev"
    >
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a
      class="carousel-control-next"
      href="#carouselExampleIndicators"
      role="button"
      data-slide="next"
    >
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>
</template>

<script>
/* eslint-disable no-undef */

import { WOW } from "wowjs";

export default {
  name: "IndexCarousel",
  data() {
    return {
      imgList: []
    };
  },
  mounted() {
    let startX = 0,
      endX = 0;
    let carouselInner = $("#carouselExampleIndicators .carousel-inner")[0];
    let carousel = $("#carouselExampleIndicators");
    carouselInner.addEventListener("touchstart", e => {
      startX = e.targetTouches[0].clientX;
    });
    carouselInner.addEventListener("touchmove", e => {
      endX = e.targetTouches[0].clientX;
      if (endX - startX > 0) {
        // 上一张
        carousel.carousel("prev");
      } else if (endX - startX < 0) {
        // 下一张
        carousel.carousel("next");
      }
    });

    let options = { live: false };
    new WOW(options).init();
    this.getBannerList();
  },
  methods: {
    getBannerList() {
      this.axios
        .get("/banner/getBannerList")
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.imgList = resp.data.data;
          }
        })
        .catch();
    }
  }
};
</script>

<style scoped lang="scss">
@media only screen and (max-width: 1140px) {
  #carouselExampleIndicators {
    margin-top: 70px;
  }
}

#carouselExampleIndicators {
  ol {
    .active {
      background-color: #ff530a;
    }

    li {
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }
  }
}
</style>
